import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-menu-gestion-citas-client',
  templateUrl: './menu-gestion-citas-client.component.html',
  styleUrls: ['./menu-gestion-citas-client.component.css']
})
export class MenuGestionCitasClientComponent implements OnInit{
  optionSelected = 0;
  menu = [
    {title: 'Nueva Cita', path:'/client/appointment-management/new-appointment', icon: 'free_cancellation'},
    {title: 'Gestión de Citas', path:'/client/appointment-management/appointment', icon: 'date_range'},
    {title: 'Historial', path:'/client/appointment-management/appointment-history', icon: 'history'},
  ];

  constructor(
    private _router: Router,
  ){}

  ngOnInit(): void {
    this.getRouteNavigation();
  }

  clickOption(id: number){
    this.optionSelected = id;
  }

  getRouteNavigation(){
    this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        let url = event.url.split('?')[0];
        this.menu.forEach((item, index) => {
          console.log('route : ', url);
          if(item.path === url){
            this.optionSelected = index;
            console.log('index : ', this.optionSelected);
          }
        });
      }
    });
  }
}
